import {Button, Col, Container, Row} from "reactstrap";
import Share from "../../../assets/img/common/share.png";
import DateIcon from "../../../assets/img/common/date.png";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {searchCourse} from "../../../services/courses";
import {useDispatch, useSelector} from "react-redux";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import ViberHeader from "../../../components/header-new/ViberHeader";
import GetPaymentModel from "../../../components/Modals/payeMentDetailsCourse/getPaymentModel";
import GetCoursePaymentDetails from "../../../components/Modals/payeMentDetailsCourse/getCoursePaymentDetails";
import * as commonFunc from "../../../utils/commonFunc";
import * as commonFun from "../../../utils/commonFunc";
// import moment from "moment";
import moment from 'moment-timezone';
import swal from "sweetalert";
import * as constants from "../../../const/constants";
import {lang, language} from "../../../const/language";

export const ViewCourseV2 = () => {

    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();

    const spinnerHandler = (data) => dispatch(actionSpinnerCreator.spinnerHandler(data));
    const userType = useSelector(state => state.auth.userType);

    const [firstViewModal, setFirstViewModal] = useState(false)
    const [viewModal, setViewModal] = useState(false)
    const [selectedInstallmentId, setSelectedInstallmentId] = useState(0)

    const [course, setCourse] = useState({
        courseId: 1,
        name: "",
        startDate: "",
        endDate: "",
        status: "",
        noOfSemesters: 0,
        noOfInstallments: 0,
        description: "",
        imageUrl: "",
        videoUrl: null,
        videoSize: 0,
        totalFee: 1000.00,
        created: "",
        updated: "",
        coursesDayTimes: [],
        courseTeachers: [],
        courseInstallmentList: [],
        nextDayOfCourseSession: "",
        courseEnrollType: null,
        coursePaymentDetails: null,
        quizAvailable: false,
        pending: false
    })

    // find teacher
    let teacher = {
        teacherName: "",
        qualification: "",
        description: "",
        imageUrl: "",
        bankNumber: "",
        bankName: "",
        branchName: "",
        accHolderName: ""
    };

    if (course.courseTeachers.length > 0) {
        teacher.teacherName = course.courseTeachers[0].name;
        teacher.qualification = course.courseTeachers[0].qualification;
        teacher.description = course.courseTeachers[0].description;
        teacher.imageUrl = course.courseTeachers[0].imageUrl;
        teacher.bankNumber = course.courseTeachers[0].bankNumber;
        teacher.bankName = course.courseTeachers[0].bankName;
        teacher.branchName = course.courseTeachers[0].branchName;
        teacher.accHolderName = course.courseTeachers[0].accHolderName;

    }

    // const [selectClass, setSelectClass] = useState({
    //     nextDayOfClass: "",
    //     dayTimes: [],
    //     description: "Your notificationBody structure closely matches the template you've provided for sending a notification through Firebase Cloud Messaging (FCM). However, there are some minor improvements you can make to ensure it aligns perfectly with the required FCM structure.",
    //     grade: "2",
    //     subject: "Maths",
    //     fee: 2000,
    //     imageUrl: "https://cdn.shopify.com/s/files/1/0100/7334/2033/files/Screenshot_2019-06-14_15.14.31_1024x1024.jpg?v=1560555240",
    //     name: 'A/L Sinhala 2025',
    //     teacher: {
    //         teacherName: "Dinuth Dheeraka",
    //         imageUrl: "https://img.freepik.com/premium-photo/woman-teacher-with-long-hair-black-shirt-with-black-background_626849-4055.jpg",
    //         qualification: "B.Sc. Agriculture Technology and Management (Peradeniya)",
    //         description: "Your notificationBody structure closely matches the template you've provided for sending a notification through Firebase Cloud Messaging (FCM). However, there are some minor improvements you can make to ensure it aligns perfectly with the required FCM structure."
    //     }
    // })

    // find if registration closed
    // let isRegistrationClosed = false;
    //
    // if (course.startDate) {
    //     isRegistrationClosed = moment().isAfter(moment(course.startDate));
    // }

    // find if registration closed
    let isRegistrationClosed = false;

    if (course.startDate) {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const localTime = moment().tz(userTimeZone);

        const registrationCloseTime = moment.tz(`${course.startDate} 23:59:59`, userTimeZone).add(21, 'days');

        isRegistrationClosed = localTime.isAfter(registrationCloseTime);
    }


    useEffect(() => {

        window.scrollTo(0, 0);

        spinnerHandler({isSpin: true, type: 15});

        (async function findCourseById() {
            try {
                if (location && location.state && location.state.id) {
                    const response = await searchCourse(Number.parseInt(location.state.id));
                    if (response && response.success && response.body) {
                        console.log(response.body)
                        setCourse(response.body)
                    }
                }
                spinnerHandler(false);
            } catch (e) {
                console.log(e)
            }
        })()

    }, []);

    const JoinToClass = () => {

        let obj = {
            id: course.courseId,
            name: course.name
        };

        commonFun.joinCourseHandler({spinnerHandler, history}, obj).then(res => {
            console.log(res)
        })
    };

    const handleRegisterOnClick = () => {

        if (!userType || userType !== 1) {
            swal({
                title: constants.GUEST_STUDENT_FOR_PURCHASE,
                icon: null,
                closeOnClickOutside: false,
                buttons: {
                    cancel: language[lang].NotNowText,
                    dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                },
            }).then((value) => {
                switch (value) {
                    case "action":
                        // location.href = (`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`)
                        history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                        break;
                    default:
                        break;
                }
            });
        }

        if(userType === 1){
            setFirstViewModal(true)
        }
    }

    // check course payment status

    let isFullCourseFeePaid = false;
    let isPartiallyPaid = false;

    if (course && course.coursePaymentDetails && course.coursePaymentDetails.length > 0) {

        // check course fee is fully paid with one installment
        if (course.courseEnrollType && course.courseEnrollType === "FULL") {
            const payment = course.coursePaymentDetails[0];
            const {buttonStatus} = payment;
            if (buttonStatus === 'BOUGHT') {
                isFullCourseFeePaid = true;
            }
        }

        // check course fee is fully paid or partially paid
        if (course.courseEnrollType && course.courseEnrollType === "INSTALLMENTS") {
            const boughtStatuses = course.coursePaymentDetails.filter(paymentDetail => {
                const {buttonStatus} = paymentDetail;
                return buttonStatus === "BOUGHT";
            })

            if (boughtStatuses.length === course.courseInstallmentList.length) {
                isFullCourseFeePaid = true;

            } else if (boughtStatuses.length > 0 && boughtStatuses.length < course.courseInstallmentList.length) {
                isFullCourseFeePaid = false;
                isPartiallyPaid = true;
            }
        }

    }

    let activeButtons = <>
        <Button
            onClick={() => {
                handleRegisterOnClick()
                // setFirstViewModal(true)
            }}
            style={{
                border: 'none',
                color: 'white',
                backgroundColor: 'maroon',
                borderRadius: 8,
                width: '100%',
                padding: 15
            }}>REGISTER FOR THE COURSE</Button>
    </>;

    // pending status
    if (course.pending) {
        activeButtons = <>
            <Button
                onClick={() => {
                }}
                style={{
                    border: 'none',
                    color: 'white',
                    backgroundColor: 'black',
                    borderRadius: 8,
                    width: '100%',
                    padding: 15
                }}>PAYMENT APPROVAL PENDING</Button>
        </>;

    } else if (isPartiallyPaid) {
        activeButtons =
            <>
                <Button
                    onClick={JoinToClass}
                    style={{
                        border: 'none',
                        color: 'white',
                        backgroundColor: '#00A1FF',
                        borderRadius: 8,
                        width: '100%',
                        padding: 13
                    }}>JOIN COURSE
                </Button>

                <Button
                    onClick={() => {
                        viewLessonsInCourse([]);
                    }}
                    style={{
                        border: 'none',
                        color: 'white',
                        backgroundColor: '#344054',
                        borderRadius: 8,
                        width: '100%',
                        padding: 13
                    }}>VIEW RESOURCES
                </Button>

                <Button
                    onClick={() => {
                        viewCoursePapers(course);
                    }}
                    style={{
                        border: 'none',
                        color: 'white',
                        backgroundColor: '#344054',
                        borderRadius: 8,
                        width: '100%',
                        padding: 13
                    }}>PAPERS
                </Button>

                <Button
                    onClick={() => {
                        handleRegisterOnClick();
                        // setFirstViewModal(true)
                    }}
                    style={{
                        border: 'none',
                        color: 'white',
                        backgroundColor: 'maroon',
                        borderRadius: 8,
                        width: '100%',
                        padding: 15
                    }}>MAKE REMAINING PAYMENTS
                </Button>
            </>;

    } else if (isFullCourseFeePaid) {
        activeButtons =
            <>
                <Button
                    onClick={JoinToClass}
                    style={{
                        border: 'none',
                        color: 'white',
                        backgroundColor: '#00A1FF',
                        borderRadius: 8,
                        width: '100%',
                        padding: 13
                    }}>JOIN COURSE
                </Button>

                <Button
                    onClick={() => {
                        viewLessonsInCourse([]);
                    }}
                    style={{
                        border: 'none',
                        color: 'white',
                        backgroundColor: '#344054',
                        borderRadius: 8,
                        width: '100%',
                        padding: 13
                    }}>VIEW RESOURCES
                </Button>

                <Button
                    onClick={() => {
                        viewCoursePapers(course);
                    }}
                    style={{
                        border: 'none',
                        color: 'white',
                        backgroundColor: '#344054',
                        borderRadius: 8,
                        width: '100%',
                        padding: 13
                    }}>PAPERS
                </Button>
            </>

    }else if(isRegistrationClosed){
        activeButtons = <>
            <Button
                onClick={() => {
                }}
                style={{
                    border: 'none',
                    color: 'white',
                    backgroundColor: 'black',
                    borderRadius: 8,
                    width: '100%',
                    padding: 15
                }}>REGISTRATION CLOSED</Button>
        </>;
    }


    let courseDescription = "";

    if (course && course.description) {
        courseDescription = course.description.replace(/\n\n/g, '</br></br>').replace(/\n/g, '</br>');
    }

    const viewCoursePapers = (course) => {
        commonFunc.viewPaperResources({spinnerHandler, userType, history}, course.courseId, false);
    };

    const viewLessonsInCourse = (lessonList) => {
        let obj = {
            history: history,
            userType: userType
        };
        commonFunc.viewCourseResources(obj, course.courseId);
    };

    return (
        <div>
            <ViberHeader/>
            {/*<Header/>*/}
            {
                firstViewModal &&
                <GetPaymentModel history={history}
                                 courseId={course.courseId}
                                 courseDetails={course} closeModal={() => {
                    setFirstViewModal(false)
                }}
                                 userType={userType}
                                 paymentModal={(data) => {
                                     setViewModal(true)
                                     setSelectedInstallmentId(data.installmentId)
                                 }}
                                 secondNav={true}
                />
            }

            {viewModal &&
                <GetCoursePaymentDetails history={history} userType={userType}
                                         courseId={course.courseId}
                                         installmentId={selectedInstallmentId}
                                         totalPayment={course.totalFee}
                                         closeModal={() => {
                                             setViewModal(false)
                                         }}
                                         amount={course.totalFee}
                                         teacher={teacher}
                />
            }

            <div>
                <main>
                    <Container
                        fluid="sm"
                        style={{marginTop: '40px', paddingLeft: '7.5%', paddingRight: '7.5%'}}>
                        <Row>
                            <Col className="" xl={9} sm={12}>
                                <Row style={{padding: 0}}>
                                    <Col xl={11} md={11} xs={11} sm={11}>
                                        <div style={{
                                            margin: 0,
                                            fontSize: 42,
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>{course && course.name}
                                        </div>
                                    </Col>
                                    <Col xl={1} md={1} sm={1} xs={1}
                                         style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
                                        <button>
                                                <span>
                                                    {/*<img src={Share} alt={''}/>*/}
                                                </span>
                                        </button>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <div style={{
                                            color: 'rgba(75,70,92,0.75)',
                                            fontSize: 19,
                                            paddingBottom: 10
                                        }}>{teacher.teacherName}
                                        </div>
                                    </Col>
                                </Row>

                                <Row className={"remove-right-border"} style={{borderRight: '1px solid #DBDADE'}}>
                                    <Col style={{paddingTop: 5}}>
                                        <img style={{
                                            width: '100%',
                                            aspectRatio: '3 / 1.6',
                                            // height: '600px',
                                            objectFit: 'contain',
                                            padding: 0,
                                            borderRadius: '8px'
                                        }}
                                             src={course && course.imageUrl} alt={''}/>
                                    </Col>
                                </Row>

                                <Row
                                    className={"remove-right-border"}
                                    style={{
                                        paddingTop: '40px',
                                        borderRight: '1px solid #DBDADE',
                                        paddingLeft: 15,
                                        paddingRight: 15
                                    }}>

                                    <Col>

                                        <Row style={{
                                            background: isFullCourseFeePaid ? 'linear-gradient(180deg, #09E870 0%, #0DAB69 100%)' : 'linear-gradient(180deg, #bf1919 0%, maroon 100%)',
                                            color: 'white',
                                            padding: '10px',
                                            borderRadius: '8px',
                                        }}>
                                            <Col style={{
                                                display: 'flex',
                                                justifyContent: 'start',
                                                alignItems: 'center'
                                            }}>
                                                <h5 style={{color: 'white', fontWeight: 'bold'}}>Full Course
                                                    Fee {isFullCourseFeePaid ? 'Paid' : ''}</h5>
                                            </Col>
                                            <Col style={{
                                                display: 'flex',
                                                justifyContent: 'end',
                                                alignItems: 'center'
                                            }}>
                                                <button style={{
                                                    backgroundColor: 'white',
                                                    fontSize: '20px',
                                                    color: isFullCourseFeePaid ? '#0DAB69' : 'maroon',
                                                    padding: '10px',
                                                    borderRadius: '20px',
                                                    fontWeight: 700,
                                                    paddingRight: 25,
                                                    paddingLeft: 25
                                                }}>
                                                    {course && `${parseFloat(course.totalFee ? course.totalFee : 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} LKR`}
                                                </button>
                                            </Col>
                                        </Row>

                                    </Col>

                                </Row>

                                <Row className={"remove-right-border"} style={{
                                    paddingTop: 30,
                                    borderRight: '1px solid #DBDADE',
                                    paddingLeft: 15,
                                    paddingRight: 15
                                }}>
                                    <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                </Row>

                                {
                                    !isFullCourseFeePaid && <Row
                                        className={"remove-right-border"}
                                        style={{paddingTop: 30, borderRight: '1px solid #DBDADE',}}>
                                        <Col style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 8
                                        }}>
                                            <Row style={{paddingBottom: 10}}>
                                                <Col style={{color: 'black'}}>
                                                    Course Installments
                                                </Col>
                                            </Row>

                                            {
                                                course.courseInstallmentList.map((installment, index) => {

                                                    let installmentNumber = "1st installment";

                                                    if (index === 1) {
                                                        installmentNumber = "2nd installment";

                                                    } else if (index === 2) {
                                                        installmentNumber = "3rd installment";

                                                    } else if (index > 2) {
                                                        installmentNumber = `${installment.id}th installment`;
                                                    }

                                                    return (
                                                        <Row key={index}>
                                                            <Col xs={4} sm={3} md={2} xl={2}>
                                                                {``}
                                                                {installmentNumber}
                                                            </Col>
                                                            <Col xs={4} sm={8} md={8} xl={8}>
                                                                {installment.amount && `${parseFloat(installment.amount ? installment.amount : 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} LKR`}
                                                            </Col>
                                                        </Row>
                                                    );
                                                })
                                            }

                                        </Col>
                                    </Row>
                                }

                                {
                                    !isFullCourseFeePaid && <Row className={"remove-right-border"} style={{
                                        paddingTop: 30,
                                        borderRight: '1px solid #DBDADE',
                                        paddingLeft: 15,
                                        paddingRight: 15
                                    }}>
                                        <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                    </Row>
                                }

                                <Row className={"remove-right-border"}
                                     style={{paddingTop: 30, borderRight: '1px solid #DBDADE', paddingBottom: 30}}>
                                    <Col>
                                        <div style={{color: 'black', fontWeight: 500}}>Description</div>
                                        <div style={{paddingTop: 10}}>
                                            <div dangerouslySetInnerHTML={{__html: courseDescription}}></div>
                                            {/*{course && course.description}*/}
                                        </div>
                                    </Col>
                                </Row>

                                <Row className={"remove-right-border visible-on-small"} style={{
                                    paddingBottom: 30,
                                    borderRight: '1px solid #DBDADE',
                                    paddingLeft: 15,
                                    paddingRight: 15,
                                    visibility: 'hidden'
                                }}>
                                    <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                </Row>

                            </Col>


                            <Col xl={3} sm={12} xs={12}>
                                <Row>
                                    <Col style={{display: 'flex', flexDirection: 'column', gap: 15}}>

                                        <div style={{color: 'black', fontSize: 16,}}>Course Schedule</div>

                                        <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
                                            <div style={{color: "#5A6080"}}>
                                                <span>
                                                      <img style={{
                                                          paddingBottom: 2,
                                                          width: 16,
                                                          height: 18,
                                                          marginRight: 10
                                                      }}
                                                           src={DateIcon} alt={''}/>
                                                </span>
                                                Course starting
                                                date: {course.startDate ? course.startDate.replaceAll("-", "/") : ""}
                                            </div>

                                            <div style={{color: '#5A6080'}}>
                                                <span>
                                                    <img
                                                        style={{
                                                            paddingBottom: 2,
                                                            width: 16,
                                                            height: 18,
                                                            marginRight: 10
                                                        }}
                                                        src={DateIcon} alt={''}/>
                                                </span>Course ending
                                                date: {course.endDate ? course.endDate.replaceAll("-", "/") : ""}
                                            </div>
                                        </div>

                                    </Col>

                                </Row>

                                <Row style={{
                                    paddingTop: 30,
                                    paddingLeft: 15,
                                    paddingRight: 15
                                }}>
                                    <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                </Row>

                                <Row style={{paddingTop: 20}}>
                                    <Col xl={12} style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'start',
                                        paddingTop: '20px',
                                        paddingBottom: '20px',
                                        gap: 12
                                    }}>
                                        {
                                            activeButtons
                                            // isFullCourseFeePaid || isPartiallyPaid ?
                                            //     <>
                                            //         <Button
                                            //             onClick={JoinToClass}
                                            //             style={{
                                            //                 border: 'none',
                                            //                 color: 'white',
                                            //                 backgroundColor: '#00A1FF',
                                            //                 borderRadius: 8,
                                            //                 width: '100%',
                                            //                 padding: 13
                                            //             }}>JOIN COURSE</Button>
                                            //         <Button
                                            //             onClick={() => {
                                            //                 viewLessonsInCourse([]);
                                            //             }}
                                            //             style={{
                                            //                 border: 'none',
                                            //                 color: 'white',
                                            //                 backgroundColor: '#344054',
                                            //                 borderRadius: 8,
                                            //                 width: '100%',
                                            //                 padding: 13
                                            //             }}>VIEW RESOURCES</Button>
                                            //         <Button
                                            //             onClick={() => {
                                            //                 viewCoursePapers(course);
                                            //             }}
                                            //             style={{
                                            //                 border: 'none',
                                            //                 color: 'white',
                                            //                 backgroundColor: '#344054',
                                            //                 borderRadius: 8,
                                            //                 width: '100%',
                                            //                 padding: 13
                                            //             }}>PAPERS</Button>
                                            //     </> :
                                            //     <>
                                            //         <Button
                                            //             onClick={() => {
                                            //                 setFirstViewModal(true)
                                            //             }}
                                            //             style={{
                                            //                 border: 'none',
                                            //                 color: 'white',
                                            //                 backgroundColor: 'maroon',
                                            //                 borderRadius: 8,
                                            //                 width: '100%',
                                            //                 padding: 15
                                            //             }}>REGISTER FOR THE COURSE</Button>
                                            //     </>
                                        }
                                    </Col>
                                </Row>

                                <Row style={{
                                    paddingTop: 30,
                                    paddingLeft: 15,
                                    paddingRight: 15
                                }}>
                                    <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                </Row>

                                <Row style={{paddingTop: 30}} className={""}>
                                    <Col className={""}>
                                        <div style={{
                                            color: 'black', fontSize: 16, fontWeight: 400, paddingBottom: 20
                                        }}>About Instructor
                                        </div>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: 'column',
                                            justifyContent: "center",
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            gap: 15,
                                        }}>
                                            <img
                                                width={"250px"}
                                                height={"250px"}
                                                alt={""}
                                                style={{objectFit: 'cover', borderRadius: 8,}}
                                                src={teacher.imageUrl}/>
                                            <h2 style={{
                                                color: 'black',
                                                fontWeight: 'bold'
                                            }}>{teacher.teacherName}</h2>
                                            <div style={{}} className={""}>
                                                {teacher.qualification.replace(/,/g, ', ')}
                                            </div>
                                            <div
                                                style={{color: 'black', textAlign: 'center'}}>{
                                                teacher.description.split(".").map((item, index) => {
                                                    return <div>{item}.<br/><br/></div>
                                                })
                                            }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </Container>
                </main>
                <CardsFooter/>
            </div>
        </div>
    )

}
